var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagKr = function SvgFlagKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 5.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M17 4H3a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 3 16h14a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 17 4M3 3.5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E01B1B",
    d: "M13.986 10.34Q14 10.173 14 10a4 4 0 1 0-7.98.41c1.143 1.199 2.844 1.906 3.98-.022 1.134-1.924 3.391-1.94 3.986-.047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A51B0",
    fillRule: "evenodd",
    d: "M13.986 10.34c-.595-1.891-2.852-1.876-3.986.048-1.136 1.928-2.837 1.22-3.98.022a4 4 0 0 0 7.966-.07",
    clipRule: "evenodd"
  })));
};
export default SvgFlagKr;